import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

import { UsuarioPerfil } from '../../../home/usuario/usuario-perfil';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.isAuth) {
      return true;
    }

    // Se não estiver autenticado, redireciona para a tela de login com returnUrl
    return this.router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  /** Valida se o perfil do usuário atualmente logado possui acesso a uma rota com base nos acessos permitidos informados */
  canActivateAcesso(acessosPermitidos: UsuarioPerfil[]): boolean {
    // Obtendo o perfil do usuário atualmente logado
    const perfil = this.authService.getPerfilUsuario();
    if (!perfil) {
      this.authService.removeSession();
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: this.router.url }
      });
      return false;
    }

    // Valida se o perfil do usuário está entre os perfis permitidos para o acesso a rota
    if (acessosPermitidos.includes(perfil)) {
      return true;
    }

    // Se não possuir acesso, redireciona para a página de acesso negado
    this.router.navigate(['/acesso-negado']);
    return false;
  }
}
